import { UserService } from './user.service';
import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardAll implements CanActivate {
  constructor(private userS: UserService, private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.userS.user) {
      return true;
    } else {
      this.router.navigate(['/login'], {
        queryParams: { redirect: state.url },
      });
      return false;
    }
  }
}

@Injectable({
  providedIn: 'root',
})
export class AuthGuardEntrega implements CanActivate {

  constructor(private userS: UserService, private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // if (this.userS.user) {
    if (this.userS.user.acesso.entrega) {
      return true;
    } else {
      this.router.navigate(['/profile'], {
        queryParams: { redirect: state.url },
      });
      return false;
    }
    // }
  }
}

@Injectable({
  providedIn: 'root',
})
export class AuthGuardCheckIn implements CanActivate {
  constructor(private userS: UserService, private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // if (this.userS.user) {
    if (this.userS.user.acesso.checkin) {
      return true;
    } else {
      this.router.navigate(['/profile'], {
        queryParams: { redirect: state.url },
      });
      return false;
    }
    // }
  }
}
